export default {
    API_BASE: '/api/v1/',
    API_KEYS: '/api/keys',
    API_LOG: '/api/v1/Log/details',
    JSON_CONTENT_TYPE: 'application/json; charset=utf-8',
    SHOP_LAST_FOUR_CREDIT_CARD: 'shop/owners?lastFourOfCreditCard=',
    SHOP_CMA_NUMBER: 'shop/owners?cmaNumber=',
    SHOP_PROFILE_KEY: 'Shop/',
    PROFILE_CREATE: 'profile',
    AUTH_REFRESH: 'Authorization/refresh',
    AUTH_LOGIN: 'Authorization/login',
    GET: 'GET',
    POST: 'POST',
    USERNAME: 'username',
    PASS: 'password',
    REFRESH_TOKEN: 'refreshToken',
    BEARER: 'Bearer ',
    LOG_API_KEY: 'Identifix-Log-Api-Key',
    SOLERA_REWARDS: 'SoleraRewards',
    ASSOCIATION_ERROR: [
        { statusCode: 400, message: 'There was an error in the format of the request.' },
        { statusCode: 403, message: 'There already exists a profile key for this shop.'},
        { statusCode: 404, message: 'The specified shop couldn\'t be found.' },
        { statusCode: 409, message: 'A resolvable conflict occurred. Wait a couple seconds, then retry.' },
        { statusCode: 500, message: 'An unexpected error occurred while processing.' }
    ]
}


// WEBPACK FOOTER //
// ./src/services/apiKeys.js